import React from 'react';
import classNames from 'classnames';
import styles from './Radio.module.less';

export default ({ handleChange, children, selected, radioStyle = {}, iconStyle, className }) => {
  const handleClick = () => {
    if (handleChange) {
      handleChange();
    }
  };
  return (
    <div className={styles.radio} onClick={handleClick} style={radioStyle}>
      <i
        className={classNames(
          { 'icon-radio': !selected },
          { 'icon-radio_active': selected },
          'iconfont',
          styles.radio_box,
          {
            [styles.active]: selected,
          },
          className,
        )}
        style={iconStyle}
      ></i>
      {children}
    </div>
  );
};
